//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalGranteeWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Grantee' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalGranteeWidget;
